import { render, staticRenderFns } from "./Breeds.vue?vue&type=template&id=278d7068"
import script from "./Breeds.vue?vue&type=script&lang=js"
export * from "./Breeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports